/**
 *
 *
 */

import { Content, Title } from 'components';
import styles from '../styles';
import { Empty, Descriptions, Flex } from 'antd';
// import { ProductDetailInformation2 } from '../../ProductRegister/components';

/**----------------------------------------
 * [Component] 총관리자: 상품상세 > 상세정보
 * ----------------------------------------
 */
const ProductDetailInformation = ({ data }) => {
  return (
    <Content
      maxWidth={'100%'}
      padding={20}
      borderRadius={4}
      style={{ marginBottom: 25 }}
      className="boxShadow"
    >
      <Title style={{ ...styles.subTitle }}>상세 정보</Title>
      {/* <InputFormTable labelWidth={160} form={form} /> */}
      {/* <ProductDetailInformation2 /> */}

      <Flex vertical gap={10}>
        {!data || !Object.keys(data).length ? (
          <div
            style={{
              width: '100%',
              height: '250px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Empty />
          </div>
        ) : (
          Object.entries(data).map(([key, value], index) => (
            <div
              key={`product_detail_data_${index}`}
              style={{ marginBottom: '15px' }}
            >
              <Title>{key}</Title>

              <div style={{ marginTop: 10 }}>
                <Descriptions
                  bordered
                  size="middle"
                  labelStyle={{
                    width: '200px',
                    backgroundColor: '#F4F4F5',
                    color: 'black',
                    fontSize: '13px',
                  }}
                  items={Object.entries(value).map(
                    ([subKey, subValue], subIndex) => ({
                      key: `${index}-${subIndex}`,
                      label: subKey,
                      children: (
                        <pre
                          style={{
                            whiteSpace: 'pre-wrap',
                            wordWrap: 'break-word',
                            overflowWrap: 'break-word',
                            wordBreak: 'break-all',
                          }}
                        >
                          {subValue}
                        </pre>
                      ),
                      span: 'filled',
                    })
                  )}
                />
              </div>
            </div>
          ))
        )}
      </Flex>
    </Content>
  );
};

export default ProductDetailInformation;
